import { createFileRoute } from "@tanstack/react-router";
import { FnbHallPage } from "../../components/participant/fnb-hall-page";

/** `/me/fnb/hall/:diningHallId` — one dining hall the participant eats at (the API answers 404 for any other). Not nested under `/me/fnb`: a full page of its own. */
export const Route = createFileRoute("/_app/me/fnb_/hall/$diningHallId")({
	component: HallPage,
});

function HallPage() {
	const { diningHallId } = Route.useParams();
	return <FnbHallPage key={diningHallId} diningHallId={diningHallId} />;
}
